import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { adminLogin, currentUser, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser && isAdmin) navigate('/admin/dashboard');
  }, [currentUser, isAdmin]);

  function messageForAuthError(err) {
    switch (err?.code) {
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
      case 'auth/user-not-found':
        return 'Incorrect email or password.';
      case 'auth/user-disabled':
        return 'This account has been disabled. Contact support.';
      case 'auth/too-many-requests':
        return 'Too many failed attempts. Please wait a few minutes and try again.';
      case 'auth/operation-not-allowed':
        return 'Email/password sign-in is currently disabled for this project.';
      case 'auth/network-request-failed':
        return 'Network error — check your connection and try again.';
      default:
        return `Sign-in failed (${err?.code || 'unknown error'}).`;
    }
  }

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await adminLogin(email, password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(messageForAuthError(err));
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, background: 'var(--green-dark)' }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🌿</div>
          <h1 style={{ color: 'white', fontSize: '1.4rem', fontWeight: 700 }}>Garden & Groundworks</h1>
          <p style={{ color: 'rgba(255,255,255,0.65)', marginTop: 4 }}>Admin access</p>
        </div>
        <div className="card">
          <h2 style={{ marginBottom: 20 }}>Sign in</h2>
          {error && <div className="error-msg">{error}</div>}
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" />
            </div>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>
        </div>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: '0.85rem' }}>
          <a href="/login" style={{ color: 'rgba(255,255,255,0.6)' }}>Client sign-in →</a>
        </p>
      </div>
    </div>
  );
}
